<template>
    <div>        
        <v-dialog v-model="showPersonSearchDialog">
            <PeopleList :useForSelection="true" :onRowSelected="onPersonSelected"/>
        </v-dialog>
          <div class="text-left">
            <v-row v-if="!hideSearch" class="ma-0 pa-0">
                <v-col cols="8" class="ma-0 pa-0">
                    <v-text-field 
                        v-model="selectedPersonId"
                        :label="label ? label : 'Person ID'" 
                        disabled />
                </v-col>
                <v-col class="ma-0 pa-0">
                    <v-btn class="mt-5" icon v-on:click="showPersonSearchDialog = true" :disabled="!isEditMode" color="primary">
                        <v-icon>mdi-account-search-outline</v-icon>
                    </v-btn>    
                </v-col>
            </v-row>
            <div v-if="personInfo && personInfo.personId">
              <v-row class="ma-0 pa-0">
                    <v-col cols="12" class="ma-0 pa-0">
                      <span class="text--secondary caption">
                        <a :href="`/admin/people/${personInfo.personId}`" target="_blank">
                            {{ personInfo.firstName }} {{ personInfo.lastName }}                            
                        </a>
                        <span v-if="personInfo.isMember">&nbsp;(Member ID#: {{personInfo.memberInfo.memberId}})</span>  
                      </span>
                    </v-col>
              </v-row>
            </div>
            <div v-else>
              <span v-if="!!selectedPersonId">Person not found</span>
            </div>             
        </div>
    </div>      
</template>
<script lang="ts">
import Vue from 'vue';
import PeopleList from "./Searches/PeopleList.vue";
import AdminCoownersList from "./AdminCoownersList.vue";

import peopleService from "@/services/admin/peopleService";

export default Vue.extend({
  name: 'AdminPersonSearchDialog',
  props: {
    personId: { type: Number },
    isEditMode: { type: Boolean },
    hideSearch: { type: Boolean },
    hideOwners: { type: Boolean },
    label: { type: String },
  },
  components: {
    AdminCoownersList,
    PeopleList
  },
  data: function() {
      return {
        showPersonSearchDialog: false,
        personInfo: {} as any,
        loadRequestId: 0,
        selectedPersonId: this.$props.personId
      };
  },
  created: function () {
    if(!!this.selectedPersonId){
      this.loadPersonInfo();
    }
  },
  methods: { 
    onPersonSelected: function({personId}: any){
        this.showPersonSearchDialog = false;
        this.selectedPersonId = personId;
        this.loadPersonInfo();
    },
    loadPersonInfo: function() {
        if (!this.selectedPersonId) {
          this.personInfo = {};
          return;
        }

        const selectedPersonId = this.selectedPersonId;
        const requestId = ++this.loadRequestId;
        this.$store.dispatch("changeLoaderStatus",true);
        peopleService.getPersonById(selectedPersonId).then((res: any) => {
          if (requestId !== this.loadRequestId || this.selectedPersonId !== selectedPersonId) return;
          if(res){
            this.personInfo = res;
          } else {
            this.personInfo = {};
          }
        }).catch(() => {
          if (requestId === this.loadRequestId && this.selectedPersonId === selectedPersonId) this.personInfo = {};
        })
        .finally(() => {
          if (requestId === this.loadRequestId) this.$store.dispatch("changeLoaderStatus",false);
        });
    },
  },
  watch: {
    personId: function(newVal, oldVal){
      if(newVal != oldVal)
        if(newVal){
          this.selectedPersonId = newVal;
          this.loadPersonInfo();
        } else {
          this.selectedPersonId = newVal;
          this.personInfo = {};        
        }       
    },
    selectedPersonId: function(newVal, oldVal){
      if (newVal !== oldVal) this.personInfo = {};
      this.$emit('update:personId', newVal);
    }
  }
});
</script>
